import React from 'react';
import { ChevronDown } from 'react-feather';
import { Card, CardBody } from 'reactstrap';
import { LI, UL } from '../../AbstractElements';

const FiltersDropdown = ({setAttendanceSheet, filterBy, setFilterBy}) => {

    const attendanceDropdownData = [
        { key: "Current Week", value: "Current Week" },
        { key: "Current Month", value: "Current Month" },
        { key: "Previous Month", value: "Previous Month" },
        { key: "Current Module", value: "Current Module" },
        { key: "Clear Filters", value: "Filter Attendance Sheet" }
    ];
    
    const handleAttendanceSheet = (value) => {
        if (value === "Filter Attendance Sheet") {
            setAttendanceSheet(false);
        } else {
            setAttendanceSheet(true);
        }
        setFilterBy(value);
    };

    return (
        <div>
            <Card className='basic-dropdown m-b-0 course-selection-card'>
                <CardBody>
                    <UL attrUL={{ className: 'd-flex flex-row flex-wrap' }}>
                        <LI attrLI={{ className: 'onhover-dropdown' }}>
                            <span className='f-w-600 nowrap'>{filterBy ? filterBy : 'Filter Attendance Sheet'}</span>
                            <span>
                                <ChevronDown className='ms-2 middle' />
                            </span>
                            <UL attrUL={{ className: `onhover-show-div left-dropdown course-options ` }}>
                                {attendanceDropdownData.map((item, index) => (
                                    <LI key={index} attrLI={{ onClick: () => handleAttendanceSheet(item.value) }}>
                                        <p className='m-0'> {item?.key}</p>
                                    </LI>
                                ))}
                            </UL>
                        </LI>
                    </UL>
                </CardBody>
            </Card>
        </div>
    )
}

export default FiltersDropdown;
